import i18n from '../i18n/config';

/**
 * Say which language this screen is in, on every request — the way the Flutter
 * client has since BUG-240.
 *
 * The server answers a request in the language the request declares, ahead of
 * the member's SAVED language: a reply is read on the screen that asked, and a
 * Spanish screen showed an Arabic refusal while the saved locale outranked it
 * (2026-10-13). Without this header the browser sends its OWN default, which is
 * a guess and not what the member chose to read here (BUG-282).
 *
 * Nothing is stored from it. `Accept-Language` with a plain value like "fr" is
 * a CORS-safelisted header, so it adds no preflight.
 */
export function uiLanguage() {
  return (i18n.resolvedLanguage || i18n.language || '').split('-')[0] || null;
}

export function attachUiLanguageHeader(instance) {
  instance.interceptors.request.use((config) => {
    const lang = uiLanguage();
    if (lang) {
      // eslint-disable-next-line no-param-reassign
      config.headers['Accept-Language'] = lang;
    }
    return config;
  });
  return instance;
}
